import {
  CardVerificationCodeElement,
  CardVerificationCodeElementProps,
  ICardVerificationCodeElement,
} from '@basis-theory/react-elements'
import React, { forwardRef } from 'react'
import { styles } from './payment-form'
import { CardBrand } from '@/hooks/use-card-brand'

interface CardCvcInputProps {
  id: string
  placeholder: string
  cardBrand: CardBrand
  onChange: CardVerificationCodeElementProps['onChange']
}

const CardCvcInput = forwardRef<ICardVerificationCodeElement, CardCvcInputProps>(
  ({ id, placeholder, cardBrand, onChange }, ref) => (
    <div className="w-full rounded-md border border-input bg-transparent shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring px-2">
      <CardVerificationCodeElement
        id={id}
        ref={ref}
        style={styles}
        placeholder={placeholder}
        cardBrand={cardBrand || undefined}
        onChange={onChange}
      />
    </div>
  ),
)

export default CardCvcInput
